<template functional>
  <div
    :style="{
      top: props.position.y + 'px',
      left: props.position.x + 'px'
    }"
    class="editor tooltip"
  >
    <slot />
  </div>
</template>

<script>
export default {
  name: 'Tooltip',
  props: {
    position: {
      type: Object,
      default: () => { return {} }
    }
  }
}
</script>

<style lang="scss" scoped>
@import '~@/uiColors';

.tooltip {
  position: fixed;
  transform: translate(-50%, -180%);
  border-radius: 10px;
  background-color: rgba($color: $color-main-darker, $alpha: 0.7);
  padding: 5px;
  font-size: 0.8em;
  white-space: nowrap;
}
</style>
